export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavTitle',
        _children: ['集計/分析']
      },
      {
        _name: 'CSidebarNavItem',
        name: '月次集計',
        to: '/admin/total/list',
        icon: 'cil-list-rich'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'プロジェクト集計',
        to: '/admin/total/list_project',
        icon: 'cil-list-rich'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['一覧']
      },
      {
        _name: 'CSidebarNavItem',
        name: '勤務表一覧',
        to: '/admin/roster/list',
        icon: 'cil-list-rich'
      },
      {
        _name: 'CSidebarNavItem',
        name: '業務報告一覧',
        to: '/admin/monthlyreports/list',
        icon: 'cil-list-rich'
      },
      {
        _name: 'CSidebarNavItem',
        name: '通勤費精算一覧',
        to: '/admin/payoff/travelCostList',
        icon: 'cil-list-rich'
      },
      {
        _name: 'CSidebarNavItem',
        name: '経費精算一覧',
        to: '/admin/payoff/expenseList',
        icon: 'cil-list-rich'
      },
      {
        _name: 'CSidebarNavItem',
        name: '休暇申請一覧',
        to: '/admin/paidandsubstitute/list',
        icon: 'cil-list-rich'
      },
      {
        _name: 'CSidebarNavItem',
        name: '予定外時間外報告一覧',
        to: '/admin/overtime/list',
        icon: 'cil-list-rich'
      },
      {
        _name: 'CSidebarNavItem',
        name: '休日出勤報告一覧',
        to: '/admin/holidaywork/list',
        icon: 'cil-list-rich'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['申請と承認']
      },
      {
        _name: 'CSidebarNavItem',
        name: '承認待ち一覧',
        to: '/submission_approval/submission_management',
        icon: 'cil-check',
        badge: null
      },
      {
        _name: 'CSidebarNavItem',
        name: '承認申請一覧',
        to: '/submission_approval/report_list',
        icon: 'cil-chevron-double-up',
        badge: null
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['月次報告']
      },
      {
        _name: 'CSidebarNavItem',
        name: '勤務表',
        to: '/report/roster',
        icon: 'cil-notes'
      },
      {
        _name: 'CSidebarNavItem',
        name: '業務報告',
        to: '/report/monthlyreport',
        icon: 'cil-notes'
      },
      {
        _name: 'CSidebarNavItem',
        name: '通勤費精算',
        to: '/payoff/travelCost',
        icon: 'cil-BusAlt'
      },
      {
        _name: 'CSidebarNavItem',
        name: '経費精算',
        to: '/payoff/expense',
        icon: 'cil-money'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['随時報告']
      },
      {
        _name: 'CSidebarNavItem',
        name: '休暇申請',
        to: '/paidandsubstitutes/list',
        icon: 'cil-notes'
      },
      {
        _name: 'CSidebarNavItem',
        name: '予定外時間外報告',
        to: '/overtimes/list',
        icon: 'cil-notes'
      },
      {
        _name: 'CSidebarNavItem',
        name: '休日出勤報告',
        to: '/holidayworks/list',
        icon: 'cil-notes'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['基本情報管理']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'プロジェクト',
        to: '/project/list',
        icon: 'cil-layers'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'クライアント',
        to: '/client/list',
        icon: 'cil-layers'
      },
      {
        _name: 'CSidebarNavItem',
        name: '部署',
        to: '/department/list',
        icon: 'cilBuilding'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ユーザ',
        to: '/users/list',
        icon: 'cilPeople'
      },
      {
        _name: 'CSidebarNavItem',
        name: '設定',
        to: '/setting/info',
        icon: 'cilSettings'
      },
    ]
  }
]
